import ThumbImg from './thumb.png';

export default {
  thumb: ThumbImg,
  url: '/doodles',
  footnote: '',
  avatar: '',
  author: '',
};
